export default __webpack_public_path__ + "static/media/sad.63cb17ea.svg";